import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
export const DropdownContent = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1vkjyyy0"
} : {
  target: "e1vkjyyy0",
  label: "DropdownContent"
})(process.env.NODE_ENV === "production" ? {
  name: "1ud9i0q",
  styles: "padding:8px 0"
} : {
  name: "1ud9i0q",
  styles: "padding:8px 0/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRyb3Bkb3duQ29udGVudC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDMEMiLCJmaWxlIjoiRHJvcGRvd25Db250ZW50LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuZXhwb3J0IGNvbnN0IERyb3Bkb3duQ29udGVudCA9IHN0eWxlZC5kaXYgYFxuICBwYWRkaW5nOiA4cHggMDtcbmA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1Ecm9wZG93bkNvbnRlbnQuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});